"use client";
import { createContext } from "react";
//#region src/heading/heading-context.tsx
const HeadingContext = createContext(0);
//#endregion
export { HeadingContext };

//# sourceMappingURL=heading-context.js.map